module.exports = __webpack_public_path__ + "img/modern-bedroom-3264490.cc3c2dd2.jpg";